import { connect } from "react-redux";
import VotifyComponent from "./VotifyComponent";

import { initializePlayback } from "../VotifyPlayback/playbackActionCreators";

const mapStateToProps = (state) => {
  return {
    partyUrl: state.party.partyUrl,
    isHost: state.party.partyId === state.host.partyId,
    isInitialized: state.playback.isInitialized,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializePlayback: () => dispatch(initializePlayback()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VotifyComponent);
